/**
 * APIL Url: ADAC.Internet.Core.Models.ModulKreditkarte.ModulKreditkartenFarbe
 * ModulKreditkartenFarbe, Werte: Undefined = 0; Blau = 1; Schwarz = 2; AdacPay = 3; 
 */
export enum ModulKreditkartenFarbeApi {
	Undefined = 0,  // Undefined
	Blau = 1,  // Blau
	Schwarz = 2,  // Schwarz
	AdacPay = 3  // AdacPay
};